import { Component } from "react";

export default class Provider extends Component {
  storageKey = "default";
  constructor(props) {
    super(props);
  }

  setStateAndSave = async stateFn => {
    await this.setStateAsync(stateFn);
    sessionStorage.setItem(this.storageKey, JSON.stringify(this.state));
  };

  setStateAsync = stateFn => {
    return new Promise(resolve => {
      this.setState(stateFn, () => {
        resolve();
      });
    });
  };

  render() {
    return;
  }
}
